module.exports = __webpack_public_path__ + "static/media/KaenguruTop.c535299e.png";